import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import ListaEventos from '../src/components/Eventos/ListaEventos'

import { Icon, Button } from 'semantic-ui-react'
import Moment from 'moment'

import 'react-toastify/dist/ReactToastify.css';

import Config from './Config'
import Eventos from '../src/services/Eventos'
import Usuarios from '../src/services/Usuarios'
import Mensagem from './components/Sistema/Mensagem'

import IsDevIndicator from '../src/components/Ambiente/IsDevIndicator'

class PagePresenca extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            ...this.state,
            message: false,
            eventoCongresso: null,
            tokenQrCode: this.props.match.params.t,
            tipocongresso: this.props.match.params.tipocongresso,
            optionLogin: this.props.match.params.tipocongresso,
            deMensagemMarcacaoPresenca: '',
            deMensagemErroMarcacaoPresenca: ''
        }
    }

    componentDidMount() {  
        Eventos.getInscricoesCongressista().then(result => {

            this.setState({
                ...this.state,
                eventosCongressista: result.data
            })
        })
        
        Eventos.getEventoCongresso(this.state.tokenQrCode)
            .then(response => {
        
                if (!response.sucesso) {
                this.setState({
                    ...this.state,
                    erro: true,
                    loading: false,
                    message:true
                })
                    return
                }

                this.setState({
                    ...this.state,
                    eventoCongresso: response.data,
                    congresso: response.data.Congresso
                })
                
                this.setState({
                    ...this.state,
                    icPresencaMarcada: false,
                    eventoCongresso: {
                        ...this.state.eventoCongresso,
                        diaEvento: Moment(this.state.eventoCongresso.InscricaoCongresso.dtInicioEvento).date(),
                        horaInicio: this.state.eventoCongresso.nuHoraInicio,
                        horaFim: this.state.eventoCongresso.nuHoraFim,
                        lblBotaoInscrever: "Marcar Presença"
                    }
                })
                
            }).catch((e) => {
              
            })

      Eventos.getCongressista().then(response => {

        if (!response.sucesso) {
          this.setState({
            ...this.state,
            erro: true,
            loading: false
          })
          return
        }

        if (response.data.idCongressoEncrypted !== Eventos.getIdCongresso()) {
          Usuarios.logout()
          response.data = null
        }

        this.setState({
          ...this.state,
          modalOpen: !Usuarios.isAuthenticated(),
          congressista: response.data
        })
      })

    }
    handleMarcarPresenca = (evento) => {
        this.setState({
          ...this.state,
          evento: evento,
          icAvaliacaoNPS: false
        }, () => {
          if (Usuarios.isAuthenticated()) {
            let user = Usuarios.getCurrentUser();
            Eventos.realizarParticipacaoEvento(
                this.state.congressista, 
                user.optLogin, 
                this.state.eventoCongresso.idEventoCongresso,
                user.iddkk).then(result => {
                  const retornoPresenca = result.SetListaPresencaParticipanteResult;
                  const erros = retornoPresenca && (retornoPresenca.$values || retornoPresenca);
                  const mensagemErro = Array.isArray(erros) && erros.length > 0
                    ? erros.map(item => item.deErro).filter(Boolean).join(' ')
                    : '';

                  if (mensagemErro) {
                    this.setState({
                      ...this.state,
                      loading: false,
                      icPresencaMarcada: false,
                      deMensagemMarcacaoPresenca: '',
                      deMensagemErroMarcacaoPresenca: mensagemErro
                    });
                    return;
                  }

                this.setState({
                  ...this.state,
                  eventos: [],
                  loading: false,
                  icPresencaMarcada: true,
                  deMensagemMarcacaoPresenca: "Presença realizada",
                  deMensagemErroMarcacaoPresenca: ''
                }, () => {
                  
                })
            })
          }
        })
        
      }

    render() {

        const eventHandlers = {
          onLogin: (u, p, c) => this.handleSucessoLogin(u, p, c),
          onHandleInscricao: (e) => this.handleMarcarPresenca(e),
          onHandleExclusao: (e) => this.handleExclusao(e),
          onEndAvaliacaoNPS: (e) => this.handleEndAvaliacaoNPS(e),
        }

        var linkLogout = <Link to={`/${Eventos.getIdCongresso()}`} >
          Voltar para tela inicial <Icon name='log out' />
        </Link>
        return <div>
                <header>
                    { <div className="container">
                    {this.state.eventoCongresso !== null &&
                        <div className='mtop10'>
                       
                        <h1>{this.state.eventoCongresso.deTitulo}</h1>
                        <div ref={this.topRef}>
                            <span className='strong'>
                            <Icon name='calendar alternate outline' />
                            Período:
                            </span>
                            {` ${this.state.eventoCongresso.Congresso.dtInicioCongresso} a ${this.state.eventoCongresso.Congresso.dtFimCongresso}`}
                        </div>
                        <div className='mtop10'>
                            <span className='strong'>
                            {this.state.eventoCongresso.Congresso.icInscricoesAbertas &&
                                <Icon name='calendar check outline' />
                            }
                            {!this.state.eventoCongresso.Congresso.icInscricoesAbertas &&
                                <Icon name='calendar times outline' />
                            }
                            Inscrições Presença: 
                            </span>
                            {` ${this.state.eventoCongresso.Congresso.dtInicioInscricao} a ${this.state.eventoCongresso.Congresso.dtFimInscricao}`}
                        </div>
                        <IsDevIndicator content={`${Config.API_URL} - ${this.state.eventoCongresso.Congresso.idCongresso}`}></IsDevIndicator>

                        </div>
                    }
                    </div>}

                </header>   
                <div className='main-content tipoPart quaseLa' >

                    <div className='container'>

                    {linkLogout}

                    {this.state.eventoCongresso != null 
                      && this.state.eventoCongresso.icLancaPresenca === false 
                      && <Mensagem
                        erro
                        Header="Evento finalizado"
                        Content="" />}

                    {this.state.eventoCongresso != null 
                      && this.state.eventoCongresso.icLancaPresenca === true 
                      && this.state.eventoCongresso && 
                        <ListaEventos
                                titulo={`Marcar Presença`}
                                source={[this.state.eventoCongresso]}
                                eventHandlers={eventHandlers} />
                    }

                    { this.state.icPresencaMarcada &&
                      <Mensagem
                        success
                        Header={this.state.deMensagemMarcacaoPresenca}
                        Content="" />
                    }

                    { this.state.deMensagemErroMarcacaoPresenca &&
                      <Mensagem
                        erro
                        Header={this.state.deMensagemErroMarcacaoPresenca}
                        Content="" />
                    }

                    </div>
                </div>
        </div>
    }
}

export default withRouter(PagePresenca)



// WEBPACK FOOTER //
// ./src/PagePresenca.js